var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNeedAccess = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FFEDC8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 24.75V13.5",
    stroke: "#D29822",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 24C30.3938 24.6862 31.3404 25.6569 31.9976 26.8177C32.6548 27.9784 33.0001 29.2896 33 30.6234V34.5",
    stroke: "#D29822",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 17.25H18C17.8011 17.25 17.6103 17.329 17.4697 17.4697C17.329 17.6103 17.25 17.8011 17.25 18V30.75",
    stroke: "#D29822",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.088 34.5L25.0011 31.3125C24.7564 30.8821 24.6919 30.3723 24.8216 29.8945C24.9513 29.4167 25.2648 29.0096 25.6936 28.762C26.1224 28.5144 26.6317 28.4465 27.1104 28.5731C27.589 28.6996 27.9982 29.0104 28.2486 29.4375L29.2499 30.9666V18C29.2499 17.8011 29.1709 17.6103 29.0302 17.4697C28.8896 17.329 28.6988 17.25 28.4999 17.25H26.9999",
    stroke: "#D29822",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 21.75L23.25 24.75L26.25 21.75",
    stroke: "#D29822",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNeedAccess, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/needAccess.47c67ed7.svg";
export { ForwardRef as ReactComponent };